import { render } from "./EditAdresseDialog.vue?vue&type=template&id=05ccd086&ts=true"
import script from "./EditAdresseDialog.vue?vue&type=script&lang=ts"
export * from "./EditAdresseDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__